import { Item } from './Item';
import { Line } from './Line';
import { BoardType } from './types';

export const Board: BoardType = ({ children, className }) => <div className={'board' + (className ? ` ${className}` : '')}>{children}</div>;

Board.Item = Item;
Board.Line = Line;
